import type { HomeEconomy } from "@/home/economy";
import type { HomeStructureCombatSnapshot, HomeStructureDefenseState } from "@/home/home-structure-types";
import {
  applyAutoStructurePotions,
  applyStructurePassiveRegen,
  canAttackStructure,
  isStructureShieldActive,
  structureCurrentHp,
} from "@/home/home-structure-defense-logic";
import {
  findSolidPlacementId,
  homeStructureCardsFromEconomy,
  homeStructureDefense,
  homeStructureMaxHp,
  homeStructureRegenPerSec,
  homeStructureStatConfigFromSettings,
} from "@/home/home-structure-stats";
import { homeStructureHpPotions } from "@/home/home-structure-economy";
import type { HomeRoomData } from "@/home/storage";
import { normalizeHomeStructureAutoHpPercent } from "@/home/home-structure-economy";

export function buildHomeStructureCombatSnapshot(
  economy: HomeEconomy,
  homeData: HomeRoomData,
  defenseState: HomeStructureDefenseState,
  now = Date.now(),
): HomeStructureCombatSnapshot {
  const config = homeStructureStatConfigFromSettings();
  const cards = homeStructureCardsFromEconomy(economy);
  let state = applyStructurePassiveRegen(defenseState, cards, homeStructureRegenPerSec(cards, config), config, now);
  const auto = applyAutoStructurePotions(state, cards, config, {
    potions: homeStructureHpPotions(economy),
    autoEnabled: economy.homeStructureAutoPotionEnabled !== false,
    autoHpPercent: normalizeHomeStructureAutoHpPercent(economy.homeStructureAutoPotionHpPercent),
  });
  state = auto.state;
  const maxHp = homeStructureMaxHp(cards, config);
  const currentHp = structureCurrentHp(maxHp, state.damageTaken);
  const shieldActive = isStructureShieldActive(state.brokenUntil, now);
  return {
    maxHp,
    defense: homeStructureDefense(cards, config),
    regenPerSec: homeStructureRegenPerSec(cards, config),
    damageTaken: state.damageTaken,
    currentHp,
    brokenUntil: state.brokenUntil,
    shieldActive,
    canBeAttacked: canAttackStructure(state, maxHp, now),
    solidPlacementId: findSolidPlacementId(homeData),
  };
}
